/* Very subtle scroll parallax on the homepage hero photograph. Moves the
   image a few pixels relative to the page as the hero scrolls through the
   viewport - enough to read as depth, not enough to notice as an effect.
   The scroll listener is only attached while the hero is actually in
   view (via IntersectionObserver) and removed the moment it isn't, so
   this costs nothing on the rest of the page. Disabled entirely under
   prefers-reduced-motion, including if the preference changes live. */
(function () {
  var RANGE = 16; // total px of travel across the hero's full scroll range

  function init() {
    var hero = document.querySelector('.kion-hero');
    if (!hero) return;

    var images = hero.querySelectorAll('.kion-hero__image-wrap > img');
    if (!images.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    var ticking = false;
    var active = false;

    function clearTransform() {
      images.forEach(function (img) {
        img.style.transform = '';
      });
    }

    function apply() {
      ticking = false;
      if (!active) return;
      var rect = hero.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var progress = 1 - rect.top / viewportH;
      progress = Math.max(0, Math.min(1, progress));
      var offset = (progress - 0.5) * RANGE;
      images.forEach(function (img) {
        img.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          active = entry.isIntersecting;
          if (active) {
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
          } else {
            window.removeEventListener('scroll', onScroll);
            clearTransform();
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(hero);

    reduceMotion.addEventListener('change', function (event) {
      if (event.matches) {
        window.removeEventListener('scroll', onScroll);
        observer.disconnect();
        clearTransform();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
